import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { BreadCrumbNav } from '../../../components/BreadCrumbNav/BreadCrumbNav';
import { selectFeatureFlags } from '../../../selectors/ContextSelector';

const transform = (breadcrumbs) => {
    let breadCrumbsArr = [];
    /* istanbul ignore else */
    if (breadcrumbs && breadcrumbs.length) {
        breadCrumbsArr = breadcrumbs.map((val) => {
            /* istanbul ignore next */
            const { linkText: breadCrumbLabel = '' } = val;
            const { link: { url: navigationState = '' } = {} } = val;
            let breadcrumbsObj = {};
            breadcrumbsObj = {
                breadCrumbLabel,
                navigationState,
            };
            return breadcrumbsObj;
        });
    }
    return breadCrumbsArr;
};

const pageTypes = {
    DEPARTMENT: 1,
    COUPONS: 1,
    MARKETING: 1,
};

const BreadCrumbNavIrisWrapper = ({ pageType, automationId, breadcrumbs, featureFlags }) => {
    const minLengthOfCrums = pageTypes[pageType] || 0;
    const { disableBreadcrumbsFirstItem = true } = featureFlags;
    const showJCPenneyCrumb = !disableBreadcrumbsFirstItem;
    const automationIdWithPage = pageType + automationId;
    const breadCrumbs = transform(breadcrumbs);
    return (
        <BreadCrumbNav
            minLengthOfCrums={minLengthOfCrums}
            theme="center"
            showJCPenneyCrumb={showJCPenneyCrumb}
            automationId={automationIdWithPage}
            breadCrumbs={breadCrumbs}
        />
    );
};
BreadCrumbNavIrisWrapper.propTypes = {
    breadcrumbs: PropTypes.oneOfType([PropTypes.array]),
    automationId: PropTypes.string,
    pageType: PropTypes.string,
    featureFlags: PropTypes.oneOfType([PropTypes.object]),
};

BreadCrumbNavIrisWrapper.defaultProps = {
    breadcrumbs: [],
    automationId: 'breadcrumbs',
    pageType: '',
    featureFlags: {},
};

const mapStateToProps = (state) => ({
    featureFlags: selectFeatureFlags(state),
});

export default connect(mapStateToProps, null)(BreadCrumbNavIrisWrapper);
